import styled from '@emotion/styled'
import MuiMenu from '@mui/material/Menu'
import MuiPopover from '@mui/material/Popover'
import { tokens } from '../../theme.js'
const colors = tokens.colors

const CrumbTrail = styled.nav`
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
  flex-wrap: nowrap;
`
const CrumbStep = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  max-width: 360px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 400 16px/1.3 ${tokens.fonts.body};
  color: ${colors.text.muted};
  &:hover {
    color: ${colors.text.body};
  }
`
const CrumbHere = styled.span`
  font: 600 18px/1.3 ${tokens.fonts.body};
  color: ${colors.text.heading};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 380px;
`
const CrumbSep = styled.span`
  font: 400 15px/1.3 ${tokens.fonts.body};
  color: ${colors.sectionDivider};
`
export function Breadcrumb({ items, onSelect, currentTestId = 'crumb-here', ...rest }) {
  return (
    <CrumbTrail aria-label="Folder path" {...rest}>
      {items.map((it, i) => (
        <span
          key={it.id ?? 'root'}
          style={{ display: 'inline-flex', alignItems: 'baseline', gap: 8, minWidth: 0, flex: i < items.length - 1 ? '0 1 auto' : '0 0 auto' }}>
          {i > 0 && <CrumbSep>›</CrumbSep>}
          {i < items.length - 1 ? (
            <CrumbStep type="button" onClick={() => onSelect(it.id)} data-testid="crumb-step" data-folder-id={it.id ?? ''} title={it.name}>
              {it.name}
            </CrumbStep>
          ) : (
            <CrumbHere data-testid={currentTestId} title={it.name}>
              {it.name}
            </CrumbHere>
          )}
        </span>
      ))}
    </CrumbTrail>
  )
}

const ActionMenuInner = styled(MuiMenu)`
  & .MuiPaper-root {
    min-width: 240px;
    border-radius: 8px;
    border: 1px solid ${colors.background.medium};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
  & .MuiMenuItem-root {
    font: 400 14px/1.4 ${tokens.fonts.body};
    color: ${colors.text.body};
    gap: 10px;
    padding: 7px 14px;
    min-height: 33px;
  }
  & .MuiMenuItem-root .MuiSvgIcon-root {
    font-size: 16px;
    color: ${colors.text.muted};
  }
  & .MuiMenuItem-root.danger,
  & .MuiMenuItem-root.danger .MuiSvgIcon-root {
    color: ${colors.error};
  }
  & .MuiDivider-root {
    margin: 4px 0;
    border-color: ${colors.background.medium};
  }
`
export function ActionMenu(props) {
  return (
    <ActionMenuInner
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      {...props}
    />
  )
}

const PopoverInner = styled(MuiPopover)`
  & .MuiPaper-root {
    border-radius: 8px;
    border: 1px solid ${colors.background.medium};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
`
export function Popover(props) {
  return (
    <PopoverInner
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: -6, horizontal: 'right' }}
      marginThreshold={8}
      {...props}
    />
  )
}
